<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <a class="muban" href="https://file.qizhangfang.net/data/down/invoiceExcel/导入购方单位模板.xlsx" >通用模板下载</a>
    <upload-excel-component :rawFile='rawFile' :on-success="handleSuccess" :before-upload="beforeUpload" />
  </div>
</template>

<script>
import UploadExcelComponent from "@/components/import/son/index.vue";
import { addCorpCustomer } from "@/api/ea";
export default {
  components: { UploadExcelComponent },
    props: {
    rawFile: ""
  },
  
  data() {
    return {
      fullscreenLoading:false
    };
  },
  methods: {
    beforeUpload(file) {
      if(!file){
        this.$message({
          message: "请选择文件",
          type: "warning"
        });
        return false;
      }
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (isLt1M) {
        return true;
      }
      this.$message({
        message: "请不要上传大于1M的文件。",
        type: "warning"
      });
      return false;
    },
    handleSuccess({ results, header }) {
      console.log(results)
      console.log(header)
      this.fullscreenLoading = true
      let items = [];
      results.map(item => {
        console.log(item);
        item.map(v=>{
          let obj = {};
          obj.tax_no = v["纳税人识别号"].toString()
          obj.name = v["纳税人名称"].toString()
          obj.short_code = v["简码"].toString()
          obj.address = v["地址"].toString()
          obj.tel = v["电话"].toString()
          obj.khhmc = v["开户行名称"].toString()
          obj.khhzh = v["开户行账号"].toString();
          obj.comId = this.$store.getters['user/comInfo'].id
          items.push(obj);
        })
      });
      console.log(items)
      addCorpCustomer(items).then(res=>{
        if(res.data.msg == 'success'){
          this.$qzfMessage("导入成功", 3)
          this.fullscreenLoading = false
          this.$emit("success")
        }
      })
    }
  }
};
</script>


<style lang="scss" scoped>
.muban {
  text-align: left;
  font-size: 14px;
  color: red;
  display: block;
  width: 150px;
}
</style>
